/**
 * IMPORTS
 */

import { all } from 'redux-saga/effects';

import apiSagas from './api-sagas';

/**
 * CORE
 */

export default function* () {
  yield all([
    ...apiSagas,
  ]);
}
